<side-panel
  [headerInfo]="{ title: this.selectedKpiByKey ? this.selectedKpiByKey.kpi.name : '--' }"
  [expanded]="sidePanelExpanded"
  (closed)="onSidePanelClosed()"
  (expandedClicked)="onExpandedPanelOpened()"
>
  <ng-container side-content *ngIf="!notAllowedError; else notAllowed">
    <page-header [title]="pageTitle" [protocolNumber]="protocolNumber ?? ''"></page-header>
    <loading-wheel
      *ngIf="isLoading; else loadedDataBlock"
      class="study-details-loading-wheel"
    ></loading-wheel>
    <ng-template #loadedDataBlock>
      <div
        class="study-details-container"
        [ngClass]="{
          'collapsed-app-content': sidebarCollapsed,
          'expanded-app-content': !sidebarCollapsed,
          'with-side-panel': sidePanelExpanded
        }"
      >
        <ai-summary-variants
          *featureFlag="'enableStudyInsightsVariants'"
          [milestones]="
            studyMilestonesRes.status === 'success' ? studyMilestonesRes.data : undefined
          "
          [kpis]="allKpisByCategory"
          (kpiClicked)="onKpiCardClicked($event)"
        ></ai-summary-variants>
        <ai-summary
          *featureFlag="'enableStudyInsights'"
          [summary]="studySummary"
          (kpiClicked)="onKpiCardClicked($event)"
        ></ai-summary>
        <study-gantt-chart
          *ngIf="studyMilestonesRes"
          [studyMilestonesRes]="studyMilestonesRes"
          [studyKpis]="allKpisByCategory"
          (expandedStagesChange)="onExpandedStagesChange($event)"
        ></study-gantt-chart>
        <kpis
          [kpisByCategory]="filteredKpisByCategory ?? allKpisByCategory"
          [selectedKpiKey]="selectedKpiByKey?.key"
          [expandedGanttChartStages]="expandedGanttChartStages"
          [keyMilestones]="keyMilestones"
          (kpiCardClicked)="onKpiCardClicked($event)"
        ></kpis>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #notAllowed>
    <error-view [type]="'not-allowed'"></error-view>
  </ng-template>

  <kpi-charts-side-panel
    side-panel-body
    *ngIf="allKpisByCategory && studyMilestonesRes"
    [kpiConfig]="kpiConfig"
    [kpisByCategory]="allKpisByCategory"
    [milestoneStages]="
      studyMilestonesRes.status === 'success' ? studyMilestonesRes.data.stages : []
    "
    [studySk]="studySk"
    [protocolNumber]="protocolNumber ?? ''"
    [selectedKpiByKey]="selectedKpiByKey"
    (sidePanelClosed)="onSidePanelClosed()"
  ></kpi-charts-side-panel>
</side-panel>
